@if (ad(); as vacancy) {
    <article class="ad">
        <img class="photo"
             [src]="vacancy.photo.src"
             [alt]="vacancy.photo.alt"
             [style.left.%]="vacancy.photo.left"
             [style.top.%]="vacancy.photo.top"
             [style.width.%]="vacancy.photo.width">

        <div class="content">
            <app-codalt-logo class="logo"></app-codalt-logo>

            <p class="eyebrow">Werken bij Codalt</p>

            <h1 class="title">{{ vacancy.title }}</h1>
            <p class="tagline">{{ vacancy.tagline }}</p>
            <p class="description">{{ vacancy.description }}</p>

            <ul class="highlights">
                @for (highlight of vacancy.highlights; track highlight) {
                    <li>{{ highlight }}</li>
                }
            </ul>

            <footer class="footer">
                <span class="location">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 21.5s-7-6.2-7-12a7 7 0 0 1 14 0c0 5.8-7 12-7 12z"/>
                        <circle cx="12" cy="9.5" r="2.6"/>
                    </svg>
                    {{ vacancy.location }}
                </span>
                <a class="link" href="https://codalt.com/werken-bij" target="_blank" rel="noopener">
                    codalt.com/werken-bij
                    <svg viewBox="0 0 32 24" aria-hidden="true">
                        <path d="M2 12h27M20 4l9 8-9 8"/>
                    </svg>
                </a>
            </footer>
        </div>
    </article>
} @else {
    <p>Deze vacature bestaat niet (meer).</p>
}
